module.exports = __webpack_public_path__ + "media/toolkits/HVAC-desktop-ecosystem-7d564d0c.png";